import { useNavigate } from 'react-router'
import {
  Dropdown,
  DropdownTrigger,
  DropdownMenu,
  DropdownItem,
  DropdownSeparator,
} from '@/design-system/molecules/Dropdown'
import { Icon } from '@/design-system/atoms/Icon'
import { useAuth } from '../../context/auth'

export default function UserDropdown() {
  const { user, logout } = useAuth()
  const navigate = useNavigate()

  const displayName =
    user?.first_name && user?.last_name
      ? `${user.first_name} ${user.last_name}`
      : user?.username || 'Usuário'

  const handleLogout = async () => {
    try {
      await logout()
      navigate('/signin')
    } catch {
      /* Silent fail */
    }
  }

  const handleProfile = () => {
    navigate('/profile')
  }

  return (
    <Dropdown>
      <DropdownTrigger>
        <button
          type="button"
          className="flex items-center gap-1 text-gray-700 dark:text-gray-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2 rounded-md px-2 py-1"
        >
          <span className="block font-medium text-theme-sm">{displayName}</span>
          <Icon name="chevron-down" size={16} />
        </button>
      </DropdownTrigger>

      <DropdownMenu className="w-60 p-2">
        <div className="px-2 py-1.5">
          <p className="font-medium text-sm text-gray-700 dark:text-gray-200">
            {displayName}
          </p>
          <p className="text-xs text-gray-500 dark:text-gray-400">
            {user?.email || ''}
          </p>
        </div>
        <DropdownSeparator />
        <DropdownItem onClick={handleProfile}>
          <Icon name="user" size={16} />
          Meu Perfil
        </DropdownItem>
        <DropdownItem onClick={handleLogout}>
          <Icon name="arrow-right" size={16} />
          Sair
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  )
}
